module.exports = __webpack_public_path__ + "img/shg55_samurai01_shop.8c54768b.png";